import React from "react";
import { useNavigate } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer = () => {
  const navigate = useNavigate();
  const handleClickOnLegal = () => {
    navigate("/legal");
  };

  const handleClickOnCookies = () => {
    navigate("/cookies");
  };

  return (
    <div style={styles.container}>
      <div>
        <p style={styles.legalButton}>
          <span
            onClick={() => handleClickOnCookies()}
            onMouseEnter={(e) => (e.target.style.fontWeight = "bold")}
            onMouseLeave={(e) => (e.target.style.fontWeight = "normal")}
            style={{ cursor: "pointer", marginRight: 20 }}
          >
            {" "}
            Cookies Policy
          </span>
          <span
            onClick={() => handleClickOnLegal()}
            onMouseEnter={(e) => (e.target.style.fontWeight = "bold")}
            onMouseLeave={(e) => (e.target.style.fontWeight = "normal")}
            style={{ cursor: "pointer", marginRight: 20 }}
          >
            {" "}
            Legal Information
          </span>
          Follow us{" "}
          <a
            href="https://www.instagram.com/gifts_4_occasion/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#E4405F", // Instagram's brand color
              textDecoration: "none",
            }}
          >
            <InstagramIcon />
          </a>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    bottom: 0,
    backgroundColor: "#FAEBD7",
  },
  legalButton: {
    textAlign: "center",
    padding: "10px",
    verticalAlign: "middle",
  },
};

export default Footer;
